import moment from "moment";
import { getRequestStatusLabel } from "../../../../../core/data/constants/requestStatus";

export const formatEmpIdForDisplay = (id: any): string => {
  if (!id) return "";
  const s = String(id).trim();
  const num = parseInt(s, 10);
  return isNaN(num) ? s : String(num);
};

export const replaceUserId = (text: string | undefined | null, empId?: string | number | null): string => {
  if (!text) return "";
  const s = String(text);
  const formattedEmpId = empId ? formatEmpIdForDisplay(empId) : "";
  const idPattern = /\bUS\w+(?:'s)?\b/g;
  return s.replace(idPattern, formattedEmpId || "");
};

export const formatStatusText = (status: string | undefined | null): string => {
  if (!status) return "Pending";
  const s = String(status).trim();
  const upper = s.toUpperCase();
  if (upper === "T" || upper === "TO BE APPROVED") return "To Be Approved";
  if (upper === "A" || upper === "APPROVED") return "Approved";
  if (upper === "R" || upper === "REJECTED") return "Rejected";
  if (upper === "P" || upper === "PENDING" || upper === "PARTIALLY APPROVED") return "Partially Approved";
  if (upper === "D" || upper === "PROCESSING COMPLETE") return "Processing Complete";
  if (upper === "N" || upper === "NEW") return "New";
  if (upper === "K" || upper === "CANCELLED") return "Cancelled";
  if (upper === "X" || upper === "DELETED") return "Deleted";
  if (upper === "B" || upper === "TO BE PROCESSED") return "To Be Processed";
  if (upper === "C" || upper === "CLOSED") return "Closed";
  if (upper === "S" || upper === "SETTLED") return "Settled";
  return getRequestStatusLabel(upper) || s;
};

export const formatStatusBadgeClass = (status: string | undefined | null): string => {
  if (!status) return "badge bg-warning text-dark";
  const s = String(status).trim();
  const upper = s.toUpperCase();
  if (
    upper === "T" ||
    upper === "TO BE APPROVED" ||
    upper === "PENDING" ||
    upper === "P" ||
    upper === "PARTIALLY APPROVED" ||
    upper === "B" ||
    upper === "TO BE PROCESSED"
  ) {
    return "badge bg-warning text-dark";
  }
  if (
    upper === "A" ||
    upper === "APPROVED" ||
    upper === "D" ||
    upper === "PROCESSING COMPLETE" ||
    upper === "S" ||
    upper === "SETTLED"
  ) {
    return "badge bg-success";
  }
  if (
    upper === "R" ||
    upper === "REJECTED" ||
    upper === "K" ||
    upper === "CANCELLED" ||
    upper === "X" ||
    upper === "DELETED"
  ) {
    return "badge bg-danger";
  }
  if (upper === "N" || upper === "NEW") {
    return "badge bg-info text-dark";
  }
  return "badge bg-secondary";
};

export const formatDarStatus = (status: string | undefined | null): string => {
  if (!status) return "N/A";
  const s = String(status).trim();
  const upper = s.toUpperCase();
  if (upper === "N" || upper === "1") return "No D&AR contemplated against the employee";
  if (upper === "P" || upper === "2" || upper.includes("DEEMED SUSPENSION"))
    return "D&AR Pending/ Deemed Suspension /Suspension/ Court Case Pending";
  if (upper === "M" || upper === "3") return "D&AR completed; Minor penalty has been imposed";
  if (upper === "J" || upper === "4") return "D&AR completed; Major penalty has been imposed";
  return s;
};

export const formatNatureOfDuty = (val: string | undefined | null, dutyObj?: any): string => {
  if (dutyObj?.nature_of_duty_title) return dutyObj.nature_of_duty_title;
  if (!val) return "N/A";
  const str = String(val).trim();
  const upper = str.toUpperCase();
  if (upper === "G" || upper === "GENERAL") return "General";
  if (upper === "S" || upper === "SHIFT") return "Shift";
  if (upper === "R" || upper === "REGULAR") return "Regular";
  if (upper === "E" || upper === "EXECUTIVE") return "Executive";
  if (upper === "01") return "Regular";
  if (upper === "02") return "Shift";
  return str;
};

export const formatCourseType = (data: any): string => {
  if (data?.course_type?.course_type_title) return data.course_type.course_type_title;
  const val = data?.diplomaOrDegree || data?.typeOfCourse;
  if (!val) return data?.otherThanDiploma && data?.otherThanDiploma !== "other" ? data.otherThanDiploma : "N/A";
  const str = String(val).trim();
  const upper = str.toUpperCase();
  if (upper === "P" || upper === "POST" || upper === "POST GRADUATION") return "Post Graduation";
  if (upper === "D" || upper === "DIPLOMA") return "Diploma";
  if (upper === "G" || upper === "DEGREE" || upper === "GRADUATION") return "Graduation";
  if (upper === "O" || upper === "OTHER") return data?.otherThanDiploma && data.otherThanDiploma !== "other" ? data.otherThanDiploma : "Other";
  return str;
};

export const formatCourseMode = (data: any): string => {
  if (data?.mode_of_course?.course_mode_title) return data.mode_of_course.course_mode_title;
  const val = data?.partTimeOrCorresp || data?.modeOfCourse;
  if (!val) return "N/A";
  const str = String(val).trim();
  const upper = str.toUpperCase();
  if (upper === "C" || upper === "CORRESPONDENCE") return "Correspondence";
  if (upper === "P" || upper === "PARTTIME" || upper === "PART TIME") return "Part Time";
  if (upper === "F" || upper === "FULLTIME" || upper === "FULL TIME") return "Full Time";
  if (upper === "R" || upper === "REGULAR") return "Regular";
  return str;
};

export const formatCourseLocation = (val: string | undefined | null): string => {
  if (!val) return "India";
  const str = String(val).trim();
  const upper = str.toUpperCase();
  if (upper === "I" || upper === "Y" || upper === "INDIA") return "India";
  if (upper === "O" || upper === "N" || upper === "OUTSIDE INDIA") return "Outside India";
  return str;
};

export const formatDate = (dateString: string | undefined | null): string => {
  if (!dateString || dateString === "Invalid date") return "N/A";
  return moment.utc(dateString).format("DD-MM-YYYY");
};

export const formatErrorMessage = (message: string): string => {
  if (!message || typeof message !== "string") return message;
  if (message.includes(" ") && !message.includes("_")) return message;
  return message
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ")
    .replace(/D&ar/i, "D&AR")
    .replace(/Noc/i, "NOC")
    .replace(/Id/i, "ID");
};

export const getOrdinalNumber = (num: string | number | undefined): string => {
  if (!num) return "-";
  const n = parseInt(String(num), 10);
  if (isNaN(n)) return String(num);
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const calculateAge = (dateOfBirth?: string | null | undefined): string => {
  if (!dateOfBirth || dateOfBirth === "N/A" || dateOfBirth === "-") return "";
  const dob = moment.utc(dateOfBirth);
  if (!dob.isValid()) return "";
  const years = moment().diff(dob, "years");
  return years > 0 ? `${years} years` : "";
};

export const extractDisplayString = (val: any, fallback = ""): string => {
  if (val === null || val === undefined) return fallback;
  if (typeof val === "string") return val;
  if (typeof val === "number") return String(val);
  if (typeof val === "object") {
    const candidate =
      val.category_title ||
      val.category_name ||
      val.department_name ||
      val.departmentName ||
      val.designation_name ||
      val.designationName ||
      val.scale ||
      val.pay_scale ||
      val.employment_type ||
      val.employmentStatus ||
      val.title ||
      val.name ||
      val.category_id ||
      val.id;
    if (candidate !== undefined && candidate !== null && typeof candidate !== "object") {
      return String(candidate);
    }
    return fallback;
  }
  return String(val);
};

